// artifact-kind — derivação de tipo de render e nome de download (DEM-2037).
//
// Separado de ArtifactViewer.tsx pra satisfazer react-refresh/only-export-
// components (o .tsx só deve exportar componentes). Usado pelo viewer e
// testável isoladamente.

import type { DemandArtifact } from '@/lib/api';

const TEXT_EXTS = new Set(['md', 'markdown', 'txt', 'json', 'csv', 'log', 'yml', 'yaml']);
const IMG_EXTS = new Set(['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'bmp', 'avif']);

export type ArtifactKind = 'image' | 'pdf' | 'html' | 'markdown' | 'text' | 'json' | 'link';

export function artifactKind(a: DemandArtifact): ArtifactKind {
  const ext = (a.extension ?? '').toLowerCase();
  const mime = (a.mime ?? '').toLowerCase();
  if (ext === 'pdf' || mime === 'application/pdf') return 'pdf';
  if (IMG_EXTS.has(ext) || mime.startsWith('image/')) return 'image';
  if (ext === 'html' || ext === 'htm' || mime === 'text/html') return 'html';
  if (ext === 'md' || ext === 'markdown' || mime === 'text/markdown') return 'markdown';
  if (ext === 'json' || mime === 'application/json') return 'json';
  if (TEXT_EXTS.has(ext) || mime.startsWith('text/')) return 'text';
  return 'link';
}

/** Nome de download por extensão real (title saneado + extensão da URL). */
export function downloadName(a: DemandArtifact): string {
  const base = (a.title || a.code || 'artifact').replace(/[^a-z0-9._-]+/gi, '-').slice(0, 80);
  if (a.extension && !base.toLowerCase().endsWith('.' + a.extension.toLowerCase())) {
    return `${base}.${a.extension}`;
  }
  return base;
}
